import http from '@/support/plugin/axios'

export const 

getAlertsByCurrentContactIdAndCompanyIdAndResource = ( companyId, actualRoute ) => http.get(`companies/${companyId}/contacts/current/alerts?resource=${actualRoute}`)